// NOTE: NSAI-7440 / NSAI-7442 — the configurable limit rules of the External
// API (/v1), as the organization and admin APIs return them. Mirrors
// apps/nsai/server/src/external-api-limits/external-api-limits.types.ts and the
// enums in external-api-limit-rule.entity.ts; the server is the authority.

export enum EExternalApiLimitTargetScope {
  PLATFORM = "platform",
  ORGANIZATION = "organization",
  PROJECT = "project",
  USER = "user",
  API_KEY = "api_key",
}

export enum EExternalApiLimitBucket {
  SHARED = "shared",
  ORGANIZATION = "organization",
  PROJECT = "project",
  USER = "user",
  API_KEY = "api_key",
  IP = "ip",
}

export enum EExternalApiLimitMetric {
  REQUESTS = "requests",
  TOTAL_TOKENS = "total_tokens",
  CONCURRENT_REQUESTS = "concurrent_requests",
}

export enum EExternalApiLimitManagedBy {
  PLATFORM = "platform",
  ORGANIZATION = "organization",
}

export enum EExternalApiLimitEndpoint {
  CHAT_COMPLETIONS = "chat_completions",
  RESPONSES = "responses",
  IMAGES = "images",
  MODELS = "models",
  FILES = "files",
}

export interface IExternalApiLimitRuleTargetRef {
  uuid: string;
  name: string | null;
}

export interface IExternalApiLimitRule {
  uuid: string;
  name: string | null;
  targetScope: EExternalApiLimitTargetScope;
  organization: IExternalApiLimitRuleTargetRef | null;
  project: IExternalApiLimitRuleTargetRef | null;
  user: IExternalApiLimitRuleTargetRef | null;
  apiKey: IExternalApiLimitRuleTargetRef | null;
  bucket: EExternalApiLimitBucket;
  metric: EExternalApiLimitMetric;
  limitValue: number;
  windowSeconds: number | null;
  endpoints: EExternalApiLimitEndpoint[] | null;
  modelNames: string[] | null;
  isEnabled: boolean;
  managedBy: EExternalApiLimitManagedBy;
}

// NOTE: The editable half of a rule. On update every field is optional and a
// null clears it (name, window, filters).
export interface IExternalApiLimitRuleSettings {
  bucket: EExternalApiLimitBucket;
  metric: EExternalApiLimitMetric;
  limitValue: number;
  name?: string | null;
  windowSeconds?: number | null;
  endpoints?: EExternalApiLimitEndpoint[] | null;
  modelNames?: string[] | null;
  isEnabled?: boolean;
}

// NOTE: Which uuid is required follows `targetScope`; `organizationUuid` is
// read by the admin API only — a tenant's rule always belongs to the
// organization in the URL.
export interface ICreateExternalApiLimitRuleBody extends IExternalApiLimitRuleSettings {
  targetScope: EExternalApiLimitTargetScope;
  organizationUuid?: string;
  projectUuid?: string;
  userUuid?: string;
  apiKeyUuid?: string;
}

export type TUpdateExternalApiLimitRuleBody =
  Partial<IExternalApiLimitRuleSettings>;

export interface ICreateOrganizationExternalApiLimitRuleParams {
  organizationUuid: string;
  body: ICreateExternalApiLimitRuleBody;
}

export interface IUpdateOrganizationExternalApiLimitRuleParams {
  organizationUuid: string;
  ruleUuid: string;
  body: TUpdateExternalApiLimitRuleBody;
}

export interface IDeleteOrganizationExternalApiLimitRuleParams {
  organizationUuid: string;
  ruleUuid: string;
}
